import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import { RECAPTCHA_SITE_KEY } from "shared/util/constants";
import ReCAPTCHA from "react-google-recaptcha";
import classnames from "classnames";

import "./LoginCaptcha.scss";

class LoginCaptcha extends React.Component {
	static propTypes = {
		onSignIn: PropTypes.func.isRequired,
		onCaptchaVerify: PropTypes.func.isRequired,
		isLoggingIn: PropTypes.bool.isRequired,
		isLoggedIn: PropTypes.bool.isRequired,
	};

	_formatSignInCopy = () => {
		const { isLoggedIn, isLoggingIn } = this.props;

		if (isLoggedIn) {
			return _str("Success!");
		}

		if (isLoggingIn) {
			return _str("Submitting…");
		}

		return _str("Sign In");
	}

	render() {
		const {
			onCaptchaVerify,
			onSignIn,
			isLoggingIn,
			isLoggedIn,
		} = this.props;
		return (
			<div
				className="oknf oknf--gray login2017-form"
			>
				<div className="login2017-login-title">
					<div className="login2017-fields-text">
						<Str>Welcome back!</Str> <br />
						<Str>Just making sure it’s really you.</Str>
					</div>
				</div>

				<div className="login-captcha login2017-fields">
					<ReCAPTCHA
						sitekey={RECAPTCHA_SITE_KEY}
						onChange={onCaptchaVerify}
					/>
				</div>

				<div className="login2017-actions">
					<button
						type="button"
						className={classnames("login2017-actions-button", {
							"isSubmitting": isLoggingIn,
							"isloggedin": isLoggedIn,
						})}
						disabled={isLoggingIn}
						onClick={() => onSignIn()}
					>
						<span>{this._formatSignInCopy()}</span>
					</button>
				</div>
			</div>
		);
	}
}

export default LoginCaptcha;



// WEBPACK FOOTER //
// ./src/apps/login_old/components/screens/LoginCaptcha.jsx